import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';

import { FeatureFlag } from '../models/feature-flag.enum';
import { FeatureFlagService } from '../services/feature-flag.service';

export const featureFlagGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const featureFlagService = inject(FeatureFlagService);
  const router = inject(Router);

  const requiredFlag: FeatureFlag = route.data['featureFlag'];

  return featureFlagService.isEnabled$(requiredFlag)() ? true : router.createUrlTree(['/']);
};
